import apiClient from "src/utils/apiClient";
import { Incident, DragonflyData, NearmissData } from "src/types/sourceDataTypes";

class SourceDataService {
  async getIncident(incidentId: string): Promise<{ data: Incident }> {
    return await apiClient.get(`/source_data/incident/${incidentId}`);
  }

  async getDragonfly(findingId: string): Promise<{ data: DragonflyData }> {
    return await apiClient.get(`/source_data/dragonfly/${findingId}`);
  }

  async getNearmiss(nearmissId: string): Promise<{ data: NearmissData }> {
    return await apiClient.get(`/source_data/nearmiss/${nearmissId}`);
  }
}

export default new SourceDataService();
